import React from 'react';

import { Flex, Text } from '@chakra-ui/react';

const Group = ({ title, children, mt }) => {

  return (
    <Flex
      mt={mt ? mt : "10px"}
      flexDir="column"
      w="100%"
      bgColor="#FFF"
    >
      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="19.6px"
        color="#95BCBF"
      >
        {title.toUpperCase()}
      </Text>
      {children}
    </Flex>
  );
}

export default Group;